import { createContext, useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import localStorageKey from "../enumerations/localStorageKey";
import { useGetRebateMode } from "../hooks/settings.hooks";
import { apiGetUserInfo, apiGetUserWalletData } from "./service";
import useLocalStorage from "./useLocalStorage";

const AuthContext = createContext({
  token: "",
  setToken: () => {},
  lang: "",
  setLang: () => {},
  defaultCurrency: "",
  setDefaultCurrency: () => {},
  userInfo: {},
  setUserInfo: () => {},
  updateUserInfo: () => {},
  userWallet: null,
  updateUserWallet: () => {},
  rebateMode: "",
  queryToken: null,
  queryLang: null,
  queryCurrency: null,
});

export const AuthContextProvider = ({ children }) => {
  const [params] = useSearchParams();
  const queryToken = params.get("token");
  const queryLang = params.get("lang");
  const queryCurrency = params.get("currency");
  const REBATE_API_PATH = ["/"];

  const [token, setToken] = useLocalStorage(localStorageKey.TOKEN);
  const [lang, setLang] = useLocalStorage(localStorageKey.DEFAULT_LANG);
  const [defaultCurrency, setDefaultCurrency] = useLocalStorage(localStorageKey.DEFAULT_CURRENCY);
  const [userWallet, setUserWallet] = useState();
  const [rebateMode, setRebateMode] = useLocalStorage(localStorageKey.REBATE_MODE);
  const [userInfo, setUserInfo] = useLocalStorage(localStorageKey.USER_INFO);
  const { data: _rebateMode, error } = useGetRebateMode({
    options: {
      enabled: !!token && REBATE_API_PATH.includes(window.location.pathname),
    },
  });
  const updateUserWallet = async () => {
    const success = await apiGetUserWalletData();
    if (success) {
      setUserWallet(success.data);
    }
  };

  const updateUserInfo = async () => {
    const success = await apiGetUserInfo();
    if (success) {
      console.log(success.data.data);
      setUserInfo(success.data.data);
    }
  };

  useEffect(() => {
    console.debug("REBATE MODE", _rebateMode);
    if (_rebateMode) {
      setRebateMode(_rebateMode);
    }
  }, [_rebateMode]);

  return (
    <AuthContext.Provider
      value={{
        rebateMode,
        lang,
        setLang,
        setToken,
        token,
        defaultCurrency,
        setDefaultCurrency,
        setUserInfo,
        userInfo,
        userWallet,
        updateUserInfo,
        updateUserWallet,
        queryCurrency,
        queryLang,
        queryToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => {
  const AuthValue = useContext(AuthContext);
  return AuthValue;
};
